import { SuperDrawerContent, SuperDrawerHeader, TabsWithContent, useSessionStorage } from "@homebound/beam";
import { Stage } from "src/generated/graphqlTypes";
import { ObservableProjectItem } from "src/routes/projects/models/ObservableProjectItem";
import { OverviewTab } from "src/routes/projects/selections/OverviewTab";
import { ProjectItemCommitmentsTable } from "src/routes/projects/selections/ProjectItemCommitmentsTable";
import { ProjectItemHistoryTab } from "src/routes/projects/selections/ProjectItemHistoryTab";
import { SpecTab } from "src/routes/projects/selections/SpecTab";

export type SelectionsSuperDrawerProps = { projectId: string; projectItem: ObservableProjectItem; stage: Stage };

export function SelectionsSuperDrawer({ projectId, projectItem, stage }: SelectionsSuperDrawerProps) {
  const [selectedTab, setSelectedTab] = useSessionStorage("selectionsSuperDrawerTab", "overview");

  const overviewTab = {
    name: "Overview",
    value: "overview",
    render: () => <OverviewTab projectId={projectId} projectItemId={projectItem.id} stage={stage} />,
  };

  const specTab = {
    name: "Spec",
    value: "specOrSelections",
    render: () => <SpecTab projectId={projectId} projectItemId={projectItem.id} stage={stage} />,
  };

  const commitmentsTab = {
    name: "Commitments",
    value: "commitments",
    render: () => <ProjectItemCommitmentsTable projectItemId={projectItem.id} />,
  };

  const historyTab = {
    name: "History",
    value: "history",
    render: () => <ProjectItemHistoryTab projectItemId={projectItem.id} />,
  };

  return (
    <SuperDrawerContent>
      <SuperDrawerHeader title={projectItem.fragment.displayName} />
      <TabsWithContent
        tabs={[overviewTab, specTab, commitmentsTab, historyTab]}
        selected={selectedTab}
        onChange={setSelectedTab}
      />
    </SuperDrawerContent>
  );
}
